<template>
	<div
		class="g-contact-info-preview"
		:class="{ 'is-h5': h5, 'is-empty': !display.hasContent }"
	>
		<div v-if="display.title" class="g-contact-info-preview__title">{{ display.title }}</div>

		<div
			v-for="row in display.rows"
			:key="row.id"
			class="g-contact-info-preview__row"
		>
			<ContactFieldIcon :type="row.type" :h5="h5" />
			<div class="g-contact-info-preview__value">{{ row.value }}</div>
			<button
				v-if="getRowActionMeta(row)"
				type="button"
				class="g-contact-info-preview__action"
				:class="{ 'is-readonly': !interactive }"
				@click.stop="onAction(row)"
			>
				{{ getRowActionMeta(row).actionLabel }}
			</button>
		</div>

		<template v-if="display.remark">
			<div v-if="display.rows.length" class="g-contact-info-preview__divider"></div>
			<div class="g-contact-info-preview__remark">{{ display.remark }}</div>
		</template>

		<div v-if="!display.hasContent" class="g-contact-info-preview__placeholder">请填写联系方式</div>
	</div>
</template>

<script>
	import ContactFieldIcon from './ContactFieldIcon.vue';
	import { getContactDisplayRows, getContactFieldMeta } from '../utils/contactInfo.js';

	export default {
		name: 'GContactInfoPreview',
		components: { ContactFieldIcon },
		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
			h5: {
				type: Boolean,
				default: false,
			},
			interactive: {
				type: Boolean,
				default: true,
			},
		},
		computed: {
			display() {
				return getContactDisplayRows(this.data);
			},
		},
		methods: {
			getFieldMeta(type) {
				return getContactFieldMeta(type);
			},
			getRowActionMeta(row) {
				const meta = getContactFieldMeta(row.type);
				if (!meta.action) return null;
				return meta;
			},
			onAction(row) {
				if (!this.interactive) return;
				const meta = this.getRowActionMeta(row);
				if (!meta) return;
				if (meta.action === 'call') {
					window.location.href = `tel:${row.value}`;
					return;
				}
				if (meta.action === 'copy') {
					this.copyText(row.value);
					return;
				}
				if (meta.action === 'map') {
					this.openMap(row.value);
				}
			},
			openMap(address) {
				const query = encodeURIComponent(address || '');
				if (!query) return;
				window.open(`https://uri.amap.com/search?keyword=${query}`, '_blank');
			},
			async copyText(text) {
				try {
					if (navigator.clipboard?.writeText) {
						await navigator.clipboard.writeText(text);
					} else {
						const input = document.createElement('textarea');
						input.value = text;
						document.body.appendChild(input);
						input.select();
						document.execCommand('copy');
						document.body.removeChild(input);
					}
					this.$message?.success?.('已复制');
				} catch (error) {
					this.$message?.error?.('复制失败');
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-contact-info-preview {
		padding: 16px 18px;
		border: 1px solid #eee;
		border-radius: 8px;
		background: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
		box-sizing: border-box;

		&.is-h5 {
			padding: 0.32rem 0.36rem;
			border-radius: 0.16rem;
		}

		&.is-empty {
			min-height: 88px;
		}
	}

	.g-contact-info-preview__title {
		margin-bottom: 14px;
		font-size: 16px;
		font-weight: 600;
		color: #333;
		line-height: 1.4;
	}

	.is-h5 .g-contact-info-preview__title {
		margin-bottom: 0.28rem;
		font-size: 0.32rem;
	}

	.g-contact-info-preview__row {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 8px 0;

		& + & {
			padding-top: 4px;
		}
	}

	.is-h5 .g-contact-info-preview__row {
		gap: 0.2rem;
		padding: 0.16rem 0;
	}

	.g-contact-info-preview__value {
		flex: 1;
		min-width: 0;
		font-size: 14px;
		color: #333;
		line-height: 1.5;
		word-break: break-all;
	}

	.is-h5 .g-contact-info-preview__value {
		font-size: 0.28rem;
	}

	.g-contact-info-preview__action {
		flex-shrink: 0;
		min-width: 28px;
		padding: 0;
		border: none;
		background: transparent;
		font-size: 14px;
		color: #285af9;
		line-height: 1.5;
		text-align: right;
		cursor: pointer;
		outline: none;

		&:hover:not(.is-readonly) {
			opacity: 0.85;
		}

		&.is-readonly {
			cursor: default;
		}
	}

	.is-h5 .g-contact-info-preview__action {
		font-size: 0.28rem;
	}

	.g-contact-info-preview__divider {
		margin: 10px 0 12px;
		border-top: 1px dashed #e8e8e8;
	}

	.is-h5 .g-contact-info-preview__divider {
		margin: 0.2rem 0 0.24rem;
	}

	.g-contact-info-preview__remark {
		font-size: 14px;
		color: #333;
		line-height: 1.6;
		word-break: break-all;
	}

	.is-h5 .g-contact-info-preview__remark {
		font-size: 0.28rem;
	}

	.g-contact-info-preview__placeholder {
		font-size: 14px;
		color: #bbb;
		line-height: 1.6;
		text-align: center;
	}

	.is-h5 .g-contact-info-preview__placeholder {
		font-size: 0.28rem;
	}
</style>
